import { render, staticRenderFns } from "./SendUserMail.vue?vue&type=template&id=686f8d20&scoped=true&"
import script from "./SendUserMail.vue?vue&type=script&lang=js&"
export * from "./SendUserMail.vue?vue&type=script&lang=js&"
import style0 from "./SendUserMail.vue?vue&type=style&index=0&id=686f8d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f8d20",
  null
  
)

export default component.exports